// Shopping cart: localStorage-backed, no backend.
const CART_KEY = 'hgtheme_cart';

// Mirrors assets/images/icons/trash.svg — inlined (not hgtheme_icon()'s
// <img>) so its stroke="currentColor" actually picks up .cart-item__remove's
// CSS color (incl. the hover color change), which an externally-referenced
// <img> can't inherit.
const TRASH_ICON = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 6H16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M8 6V4.5C8 3.94772 8.44772 3.5 9 3.5H11C11.5523 3.5 12 3.94772 12 4.5V6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 6L6.2 15.5C6.24 16.1 6.75 16.5 7.35 16.5H12.65C13.25 16.5 13.76 16.1 13.8 15.5L14.5 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.3 9V13.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="M11.7 9V13.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

function getCart() {
	try {
		const raw = localStorage.getItem(CART_KEY);
		const parsed = raw ? JSON.parse(raw) : [];
		return Array.isArray(parsed) ? parsed : [];
	} catch (e) {
		return [];
	}
}

function saveCart(cart) {
	localStorage.setItem(CART_KEY, JSON.stringify(cart));
}

function addToCart({ id, name, price, qty }) {
	const cart = getCart();
	const quantity = Math.max(1, parseInt(qty, 10) || 1);
	const existing = cart.find((item) => item.id === id);

	if (existing) {
		existing.qty += quantity;
	} else {
		cart.push({ id, name, price: parseInt(price, 10) || 0, qty: quantity });
	}

	saveCart(cart);
	updateHeaderBadge();
	return cart;
}

function setQty(id, qty) {
	let cart = getCart();
	const quantity = parseInt(qty, 10) || 0;

	if (quantity < 1) {
		cart = cart.filter((item) => item.id !== id);
	} else {
		const existing = cart.find((item) => item.id === id);
		if (existing) {
			existing.qty = quantity;
		}
	}

	saveCart(cart);
	updateHeaderBadge();
	return cart;
}

function removeFromCart(id) {
	const cart = getCart().filter((item) => item.id !== id);
	saveCart(cart);
	updateHeaderBadge();
	return cart;
}

function clearCart() {
	saveCart([]);
	updateHeaderBadge();
}

function getCartCount() {
	return getCart().reduce((sum, item) => sum + item.qty, 0);
}

function getCartTotal() {
	return getCart().reduce((sum, item) => sum + item.qty * item.price, 0);
}

function formatVND(amount) {
	return amount.toLocaleString('vi-VN') + 'đ';
}

function updateHeaderBadge() {
	const count = getCartCount();
	document.querySelectorAll('[data-cart-count]').forEach((el) => {
		el.textContent = String(count);
	});
	document.querySelectorAll('[data-cart-label]').forEach((el) => {
		el.textContent = count + ' sản phẩm';
	});
}

function cartItemMarkup(item) {
	return `
		<li class="cart-item" data-cart-item="${item.id}">
			<div class="cart-item__thumb" aria-hidden="true"></div>
			<div class="cart-item__info">
				<span class="cart-item__name">${item.name}</span>
				<span class="cart-item__price">${formatVND(item.price)}</span>
			</div>
			<div class="cart-item__qty">
				<button type="button" class="cart-item__qty-btn" data-qty-decrease aria-label="Giảm số lượng">−</button>
				<span class="cart-item__qty-value">${item.qty}</span>
				<button type="button" class="cart-item__qty-btn" data-qty-increase aria-label="Tăng số lượng">+</button>
			</div>
			<span class="cart-item__subtotal">${formatVND(item.price * item.qty)}</span>
			<button type="button" class="cart-item__remove" data-cart-remove aria-label="Xoá sản phẩm">${TRASH_ICON}</button>
		</li>
	`;
}

function renderCartPage() {
	const itemsEl = document.getElementById('cart-items');
	if (!itemsEl) {
		return;
	}

	const emptyEl = document.getElementById('cart-empty');
	const contentEl = document.getElementById('cart-content');
	const totalEl = document.getElementById('cart-total');
	const cart = getCart();

	if (emptyEl) emptyEl.hidden = cart.length !== 0;
	if (contentEl) contentEl.hidden = cart.length === 0;

	itemsEl.innerHTML = cart.map(cartItemMarkup).join('');
	if (totalEl) {
		totalEl.textContent = formatVND(getCartTotal());
	}
}

function checkoutItemMarkup(item) {
	return `
		<li class="cart-item cart-item--readonly" data-cart-item="${item.id}">
			<div class="cart-item__thumb" aria-hidden="true"></div>
			<div class="cart-item__info">
				<span class="cart-item__name">${item.name}</span>
				<span class="cart-item__price">${formatVND(item.price)} × ${item.qty}</span>
			</div>
			<span class="cart-item__subtotal">${formatVND(item.price * item.qty)}</span>
		</li>
	`;
}

function renderCheckoutSummary() {
	const itemsEl = document.getElementById('checkout-items');
	if (!itemsEl) {
		return;
	}

	const emptyEl = document.getElementById('checkout-empty');
	const contentEl = document.getElementById('checkout-content');
	const totalEl = document.getElementById('checkout-total');
	const cart = getCart();

	if (emptyEl) emptyEl.hidden = cart.length !== 0;
	if (contentEl) contentEl.hidden = cart.length === 0;

	itemsEl.innerHTML = cart.map(checkoutItemMarkup).join('');
	if (totalEl) {
		totalEl.textContent = formatVND(getCartTotal());
	}
}

// Add-to-cart controls: single delegated listener, since cards are rendered in loops.
document.addEventListener('click', (e) => {
	const addControl = e.target.closest('[data-add-to-cart]');
	if (addControl) {
		let qty = 1;
		if (addControl.dataset.qtySelector) {
			const qtyInput = document.querySelector(addControl.dataset.qtySelector);
			if (qtyInput) {
				qty = qtyInput.value;
			}
		}

		addToCart({
			id: addControl.dataset.id,
			name: addControl.dataset.name,
			price: addControl.dataset.price,
			qty,
		});

		const originalLabel = addControl.textContent;
		addControl.textContent = 'Đã thêm ✓';
		addControl.classList.add('is-added');
		window.setTimeout(() => {
			addControl.textContent = originalLabel;
			addControl.classList.remove('is-added');
		}, 1500);
		return;
	}

	// Cart-page quantity/remove controls.
	const row = e.target.closest('[data-cart-item]');
	if (!row) {
		return;
	}
	const id = row.dataset.cartItem;
	const cart = getCart();
	const item = cart.find((line) => line.id === id);
	if (!item) {
		return;
	}

	if (e.target.closest('[data-qty-increase]')) {
		setQty(id, item.qty + 1);
		renderCartPage();
	} else if (e.target.closest('[data-qty-decrease]')) {
		setQty(id, item.qty - 1);
		renderCartPage();
	} else if (e.target.closest('[data-cart-remove]')) {
		removeFromCart(id);
		renderCartPage();
	}
});

document.addEventListener('DOMContentLoaded', () => {
	updateHeaderBadge();
	renderCartPage();
	renderCheckoutSummary();
});

export {
	getCart,
	addToCart,
	setQty,
	removeFromCart,
	clearCart,
	getCartCount,
	getCartTotal,
	formatVND,
	updateHeaderBadge,
	renderCartPage,
	renderCheckoutSummary,
};
